module.exports = __webpack_public_path__ + "static/media/spinner.be80032a.gif";